import { prototypes } from '../prototypes/registry';
import { readDeviceInfo } from './deviceInfo';
import { renderOfflinePanel } from './offlinePanel';

const escapeHtml = (value: string) =>
  value.replace(
    /[&<>"']/g,
    (c) =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c] ?? c,
  );

export function renderMenu(host: HTMLElement): () => void {
  const info = readDeviceInfo();

  const cards = prototypes
    .map((p) => {
      const ready = p.status === 'ready';
      const tag = ready ? 'a' : 'div';
      const href = ready ? ` href="#/${p.id}"` : '';

      return `
        <${tag} class="card card--${p.status}"${href}>
          <div class="card__head">
            <h2>${escapeHtml(p.title)}</h2>
            <span class="badge badge--${p.status}">${ready ? 'ready' : 'planned'}</span>
          </div>
          <p class="card__summary">${escapeHtml(p.summary)}</p>
          <p class="card__proves"><span>Proves</span> ${escapeHtml(p.proves)}</p>
        </${tag}>`;
    })
    .join('');

  host.innerHTML = `
    <div class="menu">
      <header class="menu__header">
        <h1>IFP Learning Games</h1>
        <p>Web/PWA technical exploration — prototype ladder from section 5.1 of the plan.</p>
      </header>

      <a class="lane" href="#/belajar">
        <div class="lane__label">Product shape</div>
        <h2>Belajar Bersama &rarr;</h2>
        <p>
          The lesson gallery: a subtema (RPPM) of daily modules (RPPH), each a
          sequence of activity screens. This is the shippable shape; the
          prototypes below are the evidence behind it.
        </p>
      </a>

      <a class="lane lane--aset" href="#/aset">
        <div class="lane__label">For collaborators</div>
        <h2>Aset &rarr;</h2>
        <p>
          Every drawing the lessons need: what exists, what each file declares,
          and what is still missing. Artwork can be made and checked here without
          waiting for the screen that will use it.
        </p>
      </a>

      <a class="lane lane--suara" href="#/suara">
        <div class="lane__label">For collaborators</div>
        <h2>Suara &rarr;</h2>
        <p>
          Every sound the lessons need, as a recording checklist: the exact line
          for each narration, part name and recap, how it should sound, and which
          are already recorded. Narration is off in the lessons until they are.
        </p>
      </a>

      <div class="cards">${cards}</div>

      <div data-offline-host></div>

      <section class="device">
        <h3>This device</h3>
        <dl>
          <dt>Screen</dt><dd>${escapeHtml(info.screen)}</dd>
          <dt>Viewport</dt><dd>${escapeHtml(info.viewport)}</dd>
          <dt>Pixel ratio</dt><dd>${info.devicePixelRatio}</dd>
          <dt>Touch points</dt><dd>${info.maxTouchPoints}</dd>
          <dt>Graphics</dt><dd>${escapeHtml(info.graphics)}</dd>
          <dt>GPU</dt><dd>${escapeHtml(info.renderer)}</dd>
          <dt>Launched as</dt><dd>${info.standalone ? 'installed app' : 'browser tab'}</dd>
        </dl>
        <p class="device__ua">${escapeHtml(info.userAgent)}</p>
      </section>
    </div>
  `;

  const offlineHost = host.querySelector('[data-offline-host]');
  return offlineHost instanceof HTMLElement ? renderOfflinePanel(offlineHost) : () => {};
}
